import styled from '@emotion/styled';
import { Css, Flex, Link, Responsive } from '../../../ui';
import { WidgetContainer } from '../../shared/components/widget/WidgetContainer';
import Button from '../../../components/common/button/Button';
import { CardSquircleIcon } from '../../../components/common/cards/CardSquircleIcon';

export const Container = styled(WidgetContainer)`
	width: 100%;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 100%;
	}
`;

export const CheckpointLabel = styled.div`
	width: ${Css.pxToRem(147)};
	line-height: ${Css.pxToRem(24)};
	margin: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: ${Css.pxToRem(94)};
	}
`;

export const MoreInfoLink = styled(Link)`
	text-decoration: none;
	display: none;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
	}
`;

export const MoreInfoButton = styled(Button)`
	height: ${Css.pxToRem(48)};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${Css.pxToRem(12)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export const MainInformationWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(10)};
	}
`;

export const SWTCardSquircleIcon = styled(CardSquircleIcon)`
	display: none;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
	}
`;

export const StyledFlex = styled(Flex)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(8)};
	}
`;
